<template>
<div class="wrapper">
  <div v-if="!loading">
      <div>
        <CButton class="col-1 mt-3 " variant="outline" color="info" @click="print()">Print</CButton>
        <CButton class="col-3 mt-3 " variant="outline" color="info">
          <download-excel
            :data="json_data"
            :fields="json_fields"
            :name= "filename"
          >
            Download Excel
          </download-excel>
        </CButton>
      </div>
      <br>
      <div class="panel-body" id="print">
        <h3>Icare Report</h3>
        <h6>Period: {{ period }}</h6>
        <br>
        <table class="table" style="width:1000px">
          <thead>
            <tr>
              <th style="width: 10px;">#</th>
              <th style="width: 400px;">Icare Name</th>
              <th style="width: 200px;">Member Attendance</th>
              <th style="width: 200px;">Visitor Attendance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dt, index) in rpt" :key="index">
              <td>{{ index+1 }}</td>
              <td>{{ dt.icare_name }}</td>
              <td>{{ dt.count_member }}</td>
              <td>{{ dt.count_visitor }}</td>
            </tr>
          </tbody>
        </table>
      </div>    
  </div>
  <div v-else class="d-flex content-center min-vh-100">
      <b-spinner variant="primary" label="Spinning"><br></b-spinner>
  </div>


</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import report from '@/services/report';

import Vue from "vue";
import JsonExcel from "vue-json-excel";
 
Vue.component("downloadExcel", JsonExcel);

export default {
  
    data(){
        return{
          rpt:'',
          period:'',
          loading: false,
          filename: "a.xls",
          json_fields: {
              "Icare Name": "icare_name",
              "Member Attendance": "count_member",
              "Visitor Attendance": "count_visitor"

          },
          json_data: [],
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],
        }
    },
    created(){
      this.loadData()
    },
    mounted() {
      
    },
   
    methods: {
      loadData(){
        var params = {
          month: this.$route.query.month,
          year: this.$route.query.year
        }
        this.loading = true
        report.getIcareReportMonth(params)
        .then(res => {
            let getData = res.data
            this.period = res.periodMonth + ' ' + res.periodYear
            this.filename = "Icare Report " + this.period
            this.rpt = getData
            this.json_data = getData
            this.loading = false
        }).catch ((err) => { 
          alert(err.response.data.message)
        })
      },
      print () {
        // Pass the element id here
        this.$htmlToPaper('print', null, () => {
          console.log('Printing completed or was cancelled!');
        });
      },
    }
}
</script>
